import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import ColorPicker from 'react-colorpicker/ColorPicker';
import UIColorInput from 'UIComponents/color/UIColorInput';
import { getContrastColor } from '../utils/colorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class ColorPickerField extends Component {
  constructor(...args) {
    super(...args);
    this.handleColorChange = ({
      target: {
        value
      }
    }) => {
      if (value === this.color) return;
      this.props.onFieldChange({
        color: value,
        opacity: this.opacity
      });
    };
  }
  get color() {
    const {
      color
    } = this.props.value || {};
    return color;
  }
  get opacity() {
    const {
      opacity
    } = this.props.value || {};
    return opacity || opacity === 0 ? opacity : 100;
  }
  render() {
    const {
      readOnly
    } = this.props;
    const contrastColor = getContrastColor(this.color);
    return /*#__PURE__*/_jsx(UIColorInput, {
      color: this.color,
      ColorPicker: ColorPicker,
      onColorChange: this.handleColorChange,
      readOnly: readOnly,
      showInput: false,
      swatchProps: {
        borderColor: contrastColor,
        borderWidth: 1,
        iconColor: contrastColor,
        selected: true
      }
    });
  }
}
ColorPickerField.propTypes = {
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.object.isRequired
};
export default ColorPickerField;